/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type PersonSkillModal_company = {
    readonly skillLevelsEnabled: boolean | null;
    readonly person: {
        readonly id: string;
        readonly fullName: string | null;
        readonly skillPersons: ReadonlyArray<{
            readonly skill: {
                readonly id: string;
            } | null;
            readonly level: {
                readonly id: string;
                readonly description: string | null;
                readonly level: number | null;
            } | null;
        } | null> | null;
    } | null;
    readonly " $fragmentRefs": FragmentRefs<"SkillsPreviewSelector_company">;
    readonly " $refType": "PersonSkillModal_company";
};
export type PersonSkillModal_company$data = PersonSkillModal_company;
export type PersonSkillModal_company$key = {
    readonly " $data"?: PersonSkillModal_company$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"PersonSkillModal_company">;
};



const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "personId",
      "type": "ID!"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "PersonSkillModal_company",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "skillLevelsEnabled",
      "storageKey": null
    },
    {
      "alias": null,
      "args": [
        {
          "kind": "Variable",
          "name": "id",
          "variableName": "personId"
        }
      ],
      "concreteType": "Person",
      "kind": "LinkedField",
      "name": "person",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "fullName",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "SkillPerson",
          "kind": "LinkedField",
          "name": "skillPersons",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "Skill",
              "kind": "LinkedField",
              "name": "skill",
              "plural": false,
              "selections": [
                (v0/*: any*/)
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "SkillLevel",
              "kind": "LinkedField",
              "name": "level",
              "plural": false,
              "selections": [
                (v0/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "description",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "level",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SkillsPreviewSelector_company"
    }
  ],
  "type": "Company"
};
})();
(node as any).hash = 'adb56feb893c23f646a7426ebb0bfa04';
export default node;
